export default {
  RESPONSIVENESS: 'Responsiveness',
  KNOWLEDGE: 'Knowledge',
  EFFICIENCY: 'Efficiency',
  PROFESSIONALISM: 'Professionalism',
  HELPFULNESS: 'Helpfulness'
}



// WEBPACK FOOTER //
// ./src/client/misc/RatingCategories.js